/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentCheckSummaryDto
 */
export interface DeploymentCheckSummaryDto {
    /**
     * The date for which the summary has been create.
     * @type {string}
     * @memberof DeploymentCheckSummaryDto
     */
    date: string;
    /**
     * The total number of failures on this dat.
     * @type {number}
     * @memberof DeploymentCheckSummaryDto
     */
    totalFailures: number;
    /**
     * The total number of successes on this dat.
     * @type {number}
     * @memberof DeploymentCheckSummaryDto
     */
    totalSuccesses: number;
}

/**
 * Check if a given object implements the DeploymentCheckSummaryDto interface.
 */
export function instanceOfDeploymentCheckSummaryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "totalFailures" in value;
    isInstance = isInstance && "totalSuccesses" in value;

    return isInstance;
}

export function DeploymentCheckSummaryDtoFromJSON(json: any): DeploymentCheckSummaryDto {
    return DeploymentCheckSummaryDtoFromJSONTyped(json, false);
}

export function DeploymentCheckSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentCheckSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'totalFailures': json['totalFailures'],
        'totalSuccesses': json['totalSuccesses'],
    };
}

export function DeploymentCheckSummaryDtoToJSON(value?: DeploymentCheckSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'totalFailures': value.totalFailures,
        'totalSuccesses': value.totalSuccesses,
    };
}

